<template>
  <section class="grades-section">
    <div class="section-container">
      <div class="section-label">المراحل الدراسية</div>
      <h2 class="section-title">نغطي جميع المراحل</h2>
      <div class="grades-grid">
        <div class="grade-card gc-1">
          <div class="grade-icon">🏫</div>
          <h3>المرحلة الإعدادية</h3>
          <div class="grade-levels"><span>ثالثة إعدادي</span></div>
        </div>
        <div class="grade-card gc-2">
          <div class="grade-icon">📚</div>
          <h3>المرحلة الثانوية</h3>
          <div class="grade-levels">
            <span>أولى ثانوي</span>
            <span>ثانية ثانوي</span>
            <span>ثالثة ثانوي</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
.section-container { max-width:1200px;margin:0 auto;padding:0 2rem; }
.section-label { display:inline-block;background:rgba(212,175,55,.08);color:#D4AF37;border:1px solid rgba(212,175,55,.2);border-radius:99px;padding:.3rem 1rem;font-size:.8rem;font-weight:700;margin-bottom:1rem; }
.section-title { font-size:clamp(1.6rem,3vw,2.2rem);font-weight:800;color:#F0EDE4;margin-bottom:2.5rem;line-height:1.3; }

.grades-section { padding:5rem 0;background:#0D0D0D; }
.grades-grid { display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:2rem; }
.grade-card { border-radius:24px;padding:2.5rem 2rem;display:flex;flex-direction:column;gap:1.25rem;position:relative;overflow:hidden;transition:transform .3s,box-shadow .3s; }
.grade-card:hover { transform:translateY(-6px); }
.gc-1 { background:linear-gradient(135deg,#D4AF37,#C89B2D);color:#fff;box-shadow:0 20px 50px rgba(212,175,55,.25); }
.gc-2 { background:linear-gradient(135deg,#D4AF37,#B8860B);color:#fff;box-shadow:0 20px 50px rgba(212,175,55,.2); }
.grade-icon { font-size:2.5rem; }
.grade-card h3 { font-size:1.3rem;font-weight:800; }
.grade-levels { display:flex;flex-wrap:wrap;gap:.5rem; }
.grade-levels span { background:rgba(255,255,255,.2);backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,.3);border-radius:99px;padding:.3rem .9rem;font-size:.82rem;font-weight:600; }
</style>
